export default __webpack_public_path__ + "static/media/mmhd-logo.e1f31548.png";